import { CanActivateFn, RouterModule, Routes } from '@angular/router';
import { PureTeam } from '../utils/teamOwnership';
import { inject, NgModule } from '@angular/core';
import { SupportCenterRedirectService } from './services/support-center-redirect.service';

const supportCenterRedirectGuard: CanActivateFn = async route => {
    const supportCenterRedirectService = inject(SupportCenterRedirectService);
    await supportCenterRedirectService.openSupportCenter(route.queryParamMap.get('caseId'));
    return false;
};

const routes: Routes = [
    {
        path: '',
        children: [],
        title: 'Cases',
        canActivate: [supportCenterRedirectGuard],
        data: {
            ownedBy: PureTeam.DX_UI_SERVICES,
            pageHelpUrl:
                'https://support.purestorage.com/Pure1/Pure1_Manage/002_Getting_Support/00_Pure1_Manage_-_Support_Cases',
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SupportRoutingModule {}
